import facepaint from 'facepaint';

import { Breakpoints } from 'types/breakpoints';

export const mq = facepaint([
    `@media(min-width: ${Breakpoints.MOBILE + 1}px)`,
    `@media(min-width: ${Breakpoints.TABLET + 1}px)`,
    `@media(min-width: ${Breakpoints.DESKTOP}px)`,
]);
